/**
 * Filescan interaction enum for tracking events
 */
export enum FilescanInteraction {
  SimilaritySearchFilter = 'Filescan_Hunting_Similarity_Search_Filter',
  GenerateIOCQuery = 'Filescan_Indicators_of_Compromise_Generate_IOC_Query',
  DownloadReport = 'Filescan_Download_Report',
  DownloadIOCS = 'Filescan_Download_IOCS',
  ExtractedFilesDownload = 'Filescan_Extracted_Files_Download',
}

/**
 * Amplitude event names used by telemetry tracking
 */
export enum AmplitudeEvent {
  CTAClicked = 'CTA Clicked',
  AssetDownloaded = 'Asset Downloaded',
}

/**
 * Type alias for type safety
 */
export type FilescanInteractionName = FilescanInteraction | string

/**
 * Configuration for Filescan interactions
 */
export interface FilescanInteractionConfig {
  amplitude_event: AmplitudeEvent
  conversion_category: string
  conversion_type: string
  asset_type?: string
}

/**
 * Parameters for Filescan click event tracking
 */
export interface ClickEventParams {
  interaction?: FilescanInteractionName
  id?: string
  data?: Record<string, any>
}
